import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { SubpageNavbar } from '../components/SubpageNavbar';
import { Footer } from '../components/Footer';
export function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-base-cream font-body text-base-dark flex flex-col" data-id="element-267">
      <SubpageNavbar currentPage="o-projektu" data-id="element-268" />

      <main className="flex-grow pt-24 pb-20" data-id="element-269">
        <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-270">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-271">
            <h1 className="font-heading md:text-5xl lg:text-6xl text-primary mb-12 text-center text-[48px]" data-id="element-272">
              O projektu
            </h1>

            <div className="space-y-12 text-lg text-base-gray leading-relaxed" data-id="element-273">
              {/* Widescreen hero image - gallery image #15, cropped to cut sky and grass */}
              <div className="w-full aspect-[21/9] rounded-xl overflow-hidden shadow-lg mb-4" data-id="element-274">
                <img src="https://cdn.magicpatterns.com/uploads/bwjXJdQQRFAcrtLM73zcm5/xx9.png" alt="Pohled z ulice na budovu" className="w-full h-full object-cover object-center" data-id="element-275" />
              </div>

              <section data-id="element-276">
                <h2 className="font-heading text-2xl md:text-3xl text-primary mb-4" data-id="element-277">
                  Nová generace bydlení
                </h2>
                <p data-id="element-278">
                  Polyfunkční dům u sv. Václava v Dolních Jirčanech představuje
                  moderní přístup k navrhování bytových staveb s důrazem na
                  technologickou kvalitu, energetickou efektivitu a dlouhodobou
                  udržitelnost provozu. Projekt kombinuje pokročilé stavební
                  konstrukce, efektivní technické systémy a promyšlené
                  dispoziční řešení bytů.
                </p>
              </section>

              <section data-id="element-279">
                <h2 className="font-heading text-2xl md:text-3xl text-primary mb-4" data-id="element-280">
                  Energetická náročnost a provozní efektivita
                </h2>
                <p data-id="element-281">
                  Budova splňuje požadavky na výstavbu nových budov dle platné
                  legislativy a dosahuje energetické třídy A. Celková dodaná
                  energie činí cca 81 kWh/m² ročně, přičemž neobnovitelná
                  primární energie pouze 9,34 kWh/m² ročně. Významná část
                  energie (více než 90 %) je pokryta z obnovitelných zdrojů
                  prostřednictvím tepelných čerpadel.
                </p>
              </section>

              <section data-id="element-282">
                <h2 className="font-heading text-2xl md:text-3xl text-primary mb-4" data-id="element-283">
                  Konstrukční řešení
                </h2>
                <p data-id="element-284">
                  Nosná konstrukce objektu je tvořena železobetonovým systémem s
                  důrazem na optimalizaci tepelně-technických vlastností obálky
                  budovy. Obvodové stěny jsou zatepleny minerální izolací o
                  tloušťce až 200 mm, střešní konstrukce až 400 mm. Průměrný
                  součinitel prostupu tepla budovy dosahuje hodnoty 0,24 W/m²K,
                  což je lepší než referenční požadavek.
                </p>
              </section>

              <section data-id="element-285">
                <h2 className="font-heading text-2xl md:text-3xl text-primary mb-4" data-id="element-286">
                  Technické systémy budovy
                </h2>
                <p data-id="element-287">
                  Vytápění je řešeno kaskádou tepelných čerpadel vzduch–voda s
                  vysokou účinností (COP až 4,0), doplněných bivalentním
                  elektrokotlem pro špičkové zatížení. Příprava teplé vody je
                  kombinovaná – centrální systém s tepelným čerpadlem a
                  akumulací doplněný lokálními ohřívači. Větrání je zajištěno
                  lokálními rekuperačními jednotkami se zpětným získáváním
                  tepla.
                </p>
              </section>

              <section data-id="element-288">
                <h2 className="font-heading text-2xl md:text-3xl text-primary mb-4" data-id="element-289">
                  Energetický koncept
                </h2>
                <p data-id="element-290">
                  Projekt je navržen s důrazem na maximální využití energie
                  okolního prostředí. Tepelná čerpadla pokrývají většinu potřeby
                  tepla i teplé vody, čímž výrazně snižují závislost na
                  externích zdrojích energie. Budova využívá energeticky úsporné
                  LED osvětlení a připravenost na další optimalizaci spotřeby.
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer data-id="element-291" />
    </div>;
}